import React from 'react';
import EmailIcon from '../assets/images/email.png';
import PhoneIcon from '../assets/images/phone.png';
import WebsiteIcon from '../assets/images/website.png';
import FacebookIcon from '../../common/assets/images/f_logo_RGB-Blue_58.png';
import InstagramIcon from '../../common/assets/images/Instagram_Glyph_White.svg';
import What3WordsIcon from '../../common/assets/images/w3w_Symbol_RGB_Red.svg';

import '../assets/css/contact_info.css';

function ContactLine({
  icon,
  iconStyle = {},
  alt,
  link = undefined,
  children,
}) {
  return (
    <div className={'contact_info__line'}>
      <img
        className={'contact_info__line__image'}
        alt={alt}
        width={20}
        height={20}
        src={icon}
        style={iconStyle}
      />
      <span
        className={
          'gSemiBold fs-15 mg-left-12 ' + (link ? 'sb-blue txt-underline ' : '')
        }
      >
        {link ? (
          <a className='sb-blue' href={link}>
            {children}
          </a>
        ) : (
          children
        )}
      </span>
    </div>
  );
}

function formatUrl(url) {
  if (url.search(/^https?:\/\//) === -1) {
    url = 'https://' + url;
  }
  return url;
}

export default function ContactInfo({ contact, what3words }) {
  const emailLine = (
    <ContactLine
      icon={EmailIcon}
      alt={'Email Icon'}
      link={`mailto:${contact.public_email}`}
    >
      {contact.public_email}
    </ContactLine>
  );

  const phoneLine = (
    <ContactLine
      icon={PhoneIcon}
      alt={'Phone Icon'}
      link={`tel:${contact.primary_contact}`}
    >
      {contact.primary_contact}
    </ContactLine>
  );

  const websiteLine = (
    <ContactLine
      icon={WebsiteIcon}
      alt={'Internet Icon'}
      link={formatUrl(contact.website)}
    >
      Link to Website
    </ContactLine>
  );

  const facebookLine = (
    <ContactLine
      icon={FacebookIcon}
      alt={'Facebook Icon'}
      link={formatUrl(contact.facebook)}
    >
      Facebook Profile
    </ContactLine>
  );

  const instagramLine = (
    <ContactLine
      icon={InstagramIcon}
      iconStyle={{
        background:
          'radial-gradient(circle at 30% 107%, #FFD600 0%, #FF7A00 5%, #FF0069 45%,#D300C5 60%,#7638FA 90%)',
        padding: '2px',
        borderRadius: '4px',
      }}
      alt={'Instagram Icon'}
      link={formatUrl(contact.instagram)}
    >
      Instagram Profile
    </ContactLine>
  );

  const what3wordsLine = (
    <ContactLine icon={What3WordsIcon} alt={'What3Words Icon'}>
      {what3words}
    </ContactLine>
  );

  return (
    <div className={'contact_info'}>
      {what3words && what3wordsLine}
      {contact?.public_email && emailLine}
      {contact?.primary_contact && phoneLine}
      {contact?.website && websiteLine}
      {contact?.facebook && facebookLine}
      {contact?.instagram && instagramLine}
    </div>
  );
}
